import script from "./AutoSect.vue?vue&type=script&lang=ts&setup=true"
export * from "./AutoSect.vue?vue&type=script&lang=ts&setup=true"

import "./AutoSect.vue?vue&type=style&index=0&id=dbf5609c&lang=scss"

const __exports__ = script;

export default __exports__